import React from "react";
import styled from "styled-components";

import { ContentWrapper, GreyBg, H2 } from "../assets/styles/base";
import { breakpoints } from "../constants/breakpoints";
import { colors } from "../constants/colors";
import bankBawag from "../assets/banks/bank.bawag.svg";
import bankBausparkasse from "../assets/banks/bank.bausparkasse.svg";
import bankAustria from "../assets/banks/bank.austria.svg";

const Cooperation = ({ hasGreyBg, hasMarginTop }) => {
    const Content = (
        <StyledContentWrapper hasMarginTop={hasMarginTop}>
            <H2 center>Banken mit denen wir für dich zusammenarbeiten</H2>
            <List>
                <li>
                    <img src={bankBawag} alt="Bank Bawag" style={{ height: 38, filter: "grayscale(1)" }} />
                </li>
                <li>
                    <img
                        src={bankBausparkasse}
                        alt="Bank Bausparkasse"
                        style={{ height: 38, filter: "grayscale(1)" }}
                    />
                </li>
                <li>
                    <img src={bankAustria} alt="Bank Austria" style={{ height: 38, filter: "grayscale(1)" }} />
                </li>
                <li>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153.8 51.1" height={38} width={114}>
                        <g data-name="Gruppe 425">
                            <path fill="#5c5c5b" d="M102.4 0h51.4v51.1h-51.4z" data-name="Rechteck 196" />
                            <path fill="#8b8989" d="M51 0h51.4v51.1H51z" data-name="Rechteck 197" />
                            <path fill="#aaa" d="M0 0h51.4v51.1H0z" data-name="Rechteck 198" />
                            <g fill="#fff" data-name="Gruppe 424">
                                <path d="M51.4 0v3h-13V0Z" data-name="Pfad 729" />
                                <path
                                    d="m26.4 13.2-.6 2-1.7 5.5a.6.6 0 0 1-.7.6h-3a.4.4 0 0 1-.5-.4L16 7.6a3.3 3.3 0 0 1 0-.4h3.2a.5.5 0 0 1 .6.5l2.2 8.2a1.6 1.6 0 0 0 .3.6l.1-.4L25 7.7c0-.4.2-.5.7-.5a18 18 0 0 0 1.9 0 .6.6 0 0 1 .7.5l2.3 8.2a2 2 0 0 0 .3.6l.2-.5 2.2-8.3a.6.6 0 0 1 .7-.5h3.2l-.1.5-4 13c0 .4-.2.6-.6.6h-2.9a.6.6 0 0 1-.6-.5l-2.2-7.2-.2-.4Z"
                                    data-name="Pfad 730"
                                />
                                <path
                                    d="M82.4 15h9c.5 0 .5 0 .5-.6a13.7 13.7 0 0 0-.1-1.6 7 7 0 0 0-2-4.3 6.5 6.5 0 0 0-4.2-1.7A7.7 7.7 0 0 0 79 9.2a7.5 7.5 0 0 0-1.8 6 6.9 6.9 0 0 0 2.5 5 7.5 7.5 0 0 0 4.8 1.5 8.1 8.1 0 0 0 4.5-1 6.3 6.3 0 0 0 2.7-3.6l-.6-.1c-.9 0-1.7 0-2.6-.2a.8.8 0 0 0-1 .5 3.1 3.1 0 0 1-3.1 1.5 2.9 2.9 0 0 1-2.6-2.4l-.2-.7c0-.7 0-.7.7-.7Zm.6-5a2.9 2.9 0 0 1 3.3-.1 3 3 0 0 1 1.2 2.8h-5.7A3.2 3.2 0 0 1 83 9.9Z"
                                    data-name="Pfad 731"
                                />
                                <path
                                    d="M132.9 12.9a6.6 6.6 0 0 0-4.3-5.6 8.2 8.2 0 0 0-5.6 0 6 6 0 0 0-3.5 2.6 8.3 8.3 0 0 0-.2 8.2c1.3 2.6 3.6 3.6 6.3 3.6h1a6.6 6.6 0 0 0 5.6-3.7 8.4 8.4 0 0 0 .7-5.1Zm-4.4 2.3a8.4 8.4 0 0 1-.5 2.1 2.3 2.3 0 0 1-2.4 1.6 2.4 2.4 0 0 1-2.3-1.6 7.6 7.6 0 0 1-.4-3.1 7.5 7.5 0 0 1 .4-2.9 2.4 2.4 0 0 1 3-1.6 2.4 2.4 0 0 1 1.7 1.5 7.9 7.9 0 0 1 .5 4Z"
                                    data-name="Pfad 732"
                                />
                                <path
                                    d="m97.7 9.3.3-.5a4.7 4.7 0 0 1 4.5-2 6.5 6.5 0 0 1 1.2.2 3.7 3.7 0 0 1 2.8 3.2 10.6 10.6 0 0 1 .2 2v8.6c0 .4-.1.6-.6.6h-3c-.5 0-.6-.2-.6-.6V13a10 10 0 0 0 0-1.2 2 2 0 0 0-1.3-2 2.4 2.4 0 0 0-2.5.8 3.7 3.7 0 0 0-.8 2.6v7.6c0 .6 0 .6-.6.6h-3.1c-.4 0-.5-.1-.5-.5V7.6c0-.3.1-.4.5-.4h3c.3 0 .4.1.4.5v1.5Z"
                                    data-name="Pfad 733"
                                />
                                <path
                                    d="m47.4 19.3-.2.3a4.6 4.6 0 0 1-4.5 2.1 6.4 6.4 0 0 1-1.5-.2 3.9 3.9 0 0 1-2.7-3.6 10.7 10.7 0 0 1 0-1.5V7.8c0-.5 0-.6.5-.6h3c.6 0 .6 0 .6.6v7.8a9.7 9.7 0 0 0 0 1.2 1.9 1.9 0 0 0 1.2 1.8 2.3 2.3 0 0 0 2.4-.5 3.1 3.1 0 0 0 1-2.4V7.8c0-.6 0-.6.6-.6h3c.4 0 .5.1.5.5v13.2c0 .3 0 .5-.4.5h-3c-.3 0-.4-.2-.4-.5v-1.6Z"
                                    data-name="Pfad 734"
                                />
                                <path
                                    d="m52.6 17.4 2.5-.3c.6-.2 1-.1 1.3.5a2.2 2.2 0 0 0 1.4 1 5 5 0 0 0 2.9.2 2.4 2.4 0 0 0 1-.5 1.1 1.1 0 0 0-.4-2c-1-.2-2-.3-2.9-.6a20.8 20.8 0 0 1-3-.9c-3-1.3-2.7-5-.9-6.5a6.3 6.3 0 0 1 3.6-1.5 8.7 8.7 0 0 1 4.3.5 5.2 5.2 0 0 1 3 3 4.7 4.7 0 0 1-.4.2l-2.5.4a.7.7 0 0 1-.5-.1c-.8-1.3-2-1.4-3.3-1.3a3 3 0 0 0-1 .2 1.2 1.2 0 0 0-.8 1.2 1 1 0 0 0 .9 1l3 .7a18.1 18.1 0 0 1 3 .8 3.9 3.9 0 0 1 1.1 6.3 6.2 6.2 0 0 1-3.5 1.8A10 10 0 0 1 56 21a5.4 5.4 0 0 1-3.2-3l-.2-.7Z"
                                    data-name="Pfad 735"
                                />
                                <path
                                    d="M135.7 13.8v-3.4c0-.4 0-.5-.4-.5h-1.5c-.3 0-.4 0-.4-.3v-2c0-.3 0-.4.3-.4h1.7c.3 0 .5 0 .5-.5l.1-3.1c0-.3.1-.4.4-.4l3.2-.2c.3 0 .3.1.3.4v3.3c0 .4.1.5.5.5h2c.3 0 .5.1.5.4v2c0 .2-.1.3-.4.3h-2.2c-.3 0-.4.1-.4.4V17c0 1.2.5 1.7 1.7 1.7a7 7 0 0 0 1-.1c.3 0 .4 0 .4.3l.2 2.4a.4.4 0 0 1-.3.3 10.7 10.7 0 0 1-4.2 0 3.5 3.5 0 0 1-2.9-3.5v-4.2Z"
                                    data-name="Pfad 736"
                                />
                                <path
                                    d="M69 14.1v-3.5c0-.7 0-.7-.6-.7H67c-.2 0-.3-.1-.3-.4V7.6c0-.3 0-.4.4-.4h1.7c.3 0 .4 0 .4-.4l.1-3c0-.4.1-.6.5-.6l3-.2c.4 0 .4.1.4.4v3.3c0 .4.1.5.5.5h2.1c.3 0 .4.1.4.4v2c0 .3-.1.3-.4.3h-2.2c-.3 0-.4.1-.4.4v6.5c0 1.3.5 1.8 1.8 1.8a5.7 5.7 0 0 0 1-.1c.2 0 .3 0 .3.3l.2 2.2c0 .3 0 .5-.4.5a11.5 11.5 0 0 1-3.7.1 3.6 3.6 0 0 1-3.3-3.8v-3.7Z"
                                    data-name="Pfad 737"
                                />
                                <path
                                    d="m113.2 9.4.2-.3a4 4 0 0 1 4-2.3c.4 0 .5.2.5.4v3c0 .3-.1.4-.4.4a7.1 7.1 0 0 0-1.5.2 3.2 3.2 0 0 0-2.4 3.3v6.6c0 .7 0 .7-.7.7H110c-.6 0-.6 0-.6-.7v-13c0-.4.1-.5.5-.5h2.7c.4 0 .5.2.5.5v1.7Z"
                                    data-name="Pfad 738"
                                />
                            </g>
                        </g>
                    </svg>
                </li>
                <li>
                    <svg
                        version="1.1"
                        id="EBENE"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        viewBox="0 0 903.283 466.866"
                        height={48}
                        width={93}
                    >
                        <path d="M466.862 30.444h405.983v405.975H466.862zM30.434 30.444h405.983v405.975H30.434z" />
                        <path
                            class="st1"
                            fill="#fff"
                            d="M828.94 161.254h-78.184L702 236.09c-15.429 23.664-28.715 38.268-51.172 38.268-23.554 0-41.783-16.361-41.783-40.794 0-24.488 17.68-41.729 40.74-41.783 10.063 0 20.174 3.66 26.264 8.546l18.638-28.72c-11.351-9.036-26.144-14.691-44.575-14.691-44.637 0-77.197 33.163-76.648 77.856.55 43.1 32.889 74.616 77.362 75.164 45.798.546 80.444-17.154 179.382-146.11.937-1.31.39-2.572-1.268-2.572m1.315-10.98c7.303 0 12.135 4.886 12.135 11.255 0 3.348-.934 5.654-4.009 9.663-98.884 128.533-136.055 150.275-187.555 149.726-50.513-.55-87.793-36.952-88.343-86.091-.548-50.568 36.842-88.892 87.464-88.892 25.463 0 45.806 9.87 59.218 24.02l-30.955 46.742c-6.382-7.322-15.484-13.936-27.987-13.936-17.46 0-30.197 12.354-30.197 30.858 0 18.338 13.452 29.758 30.802 29.758 16.307 0 27.014-10.102 42.77-34.315l51.283-78.789h85.374zm-319.492 10.983c-1.647 0-2.37 1.334-1.471 2.714l27.678 42.487c2.214-18.374 10.664-34.502 20.054-45.204l-46.261.003zm32.943 74.228-43.486-65.173c-2.25-3.348-2.908-5.435-2.908-8.783 0-6.37 4.83-11.256 12.133-11.256h72.695c-22.732 17.898-39.752 49.305-38.434 85.212M128.16 187.711c0 8.752-3.62 14.285-11.669 14.285-4.023 0-7.443-1.51-9.657-4.125v-23.942c2.113-2.917 5.332-4.83 10.362-4.83 8.652 0 10.965 6.54 10.965 14.085v4.527zm12.777-.604v-3.823c0-14.385-5.734-25.854-21.226-25.854-5.332 0-9.758 1.51-12.977 4.527v-22.836H93.757v72.934h9.657l1.308-3.722c3.42 3.622 8.752 5.232 14.084 5.232 14.889 0 22.131-10.564 22.131-26.458m39.431 6.439c0 5.835-3.722 9.255-10.864 9.255-5.23 0-7.545-1.911-7.545-6.438 0-4.93 2.817-6.339 11.972-7.446l6.437-.804v5.433zm12.877 18.812c2.213 0 4.527-.1 6.54-.303V200.99c-1.61.2-2.415.2-3.32.2-2.315 0-3.018-1.106-3.018-4.124v-21.93c0-10.462-3.622-17.706-20.623-17.706-12.475 0-21.427 4.225-21.427 17.404l11.67.905c.1-6.337 3.52-7.745 9.052-7.745 6.64 0 8.25 2.213 8.25 7.243v4.727l-10.262 1.006c-14.788 1.409-21.225 4.93-21.225 16.7 0 10.563 6.94 15.392 18.107 15.392 8.852 0 14.184-3.019 17.102-8.45.704 4.928 3.22 7.746 9.154 7.746m47.278-.303H253.6v-33.8c0-13.983-6.035-20.825-18.006-20.825-7.043 0-12.375 2.315-16.097 5.835l-1.508-4.325h-9.657v53.115h13.077v-38.428c2.918-2.817 6.137-4.325 10.262-4.325 6.84 0 8.852 4.325 8.852 10.965v31.788zm53.515-31.788 19.013-21.327h-14.688l-20.421 23.942v-43.76h-12.977v72.933h12.977v-16.699c2.314-1.308 4.83-3.32 7.344-5.734l13.18 22.433h14.787l-19.215-31.788zM229.185 265.58c0 14.377-9.165 21.33-20.7 21.33-13.273 0-20.225-8.058-20.225-20.382 0-15.011 9.164-21.175 20.542-21.175 13.746 0 20.383 8.533 20.383 20.227m-75.69 0c0 14.377-9.165 21.33-20.701 21.33-13.272 0-20.225-8.058-20.225-20.382 0-15.011 9.166-21.175 20.542-21.175 13.747 0 20.384 8.533 20.384 20.227m96.863 1.896c0-26.862-15.01-40.767-41.241-40.767-18.642 0-31.876 7.427-38.124 20.865-5.926-13.772-18.88-20.865-37.566-20.865-26.546 0-42.19 15.01-42.19 41.082 0 23.386 14.063 37.923 37.607 37.923 5.531 0 10.746-1.58 14.853-3.95-7.742 13.43-19.435 28.284-30.495 40.135h24.492c11.305-13.232 26.797-33.15 33.564-54.312 5.845 11.489 17.391 18.127 33.277 18.127 5.53 0 10.744-1.58 14.853-3.95-7.742 13.43-19.436 28.284-30.497 40.135h24.492c14.853-17.382 36.975-46.298 36.975-74.423"
                        />
                    </svg>
                </li>
                <li>
                    <span className="count">+</span>
                    <span className="name">
                        viele weitere
                        <br />
                        Bankpartner
                    </span>
                </li>
            </List>
        </StyledContentWrapper>
    );
    if (hasGreyBg) return <GreyBg>{Content}</GreyBg>;
    return Content;
};

const StyledContentWrapper = styled(ContentWrapper)`
    color: ${colors.primary};
    margin-top: ${({ hasMarginTop }) => (hasMarginTop ? "50px" : "0")};

    @media (min-width: ${breakpoints.tabletBigMin}) {
        margin-top: ${({ hasMarginTop }) => (hasMarginTop ? "100px" : "0")};
    }

    ul {
        align-items: center;
        display: flex;
        list-style: none;
        flex-wrap: wrap;
        justify-content: space-around;
        margin: 0 0 -30px;
        padding: 0;
        width: 100%;
    }
    li {
        margin: 0 12px 30px;

        @media (min-width: 930px) and (max-width: 1047px) {
            margin-left: 35px;
            margin-right: 35px;
        }

        :last-child {
            align-items: center;
            display: flex;

            .count {
                font-size: 46px;
                font-weight: 500;
            }
            .name {
                font-size: 16px;
                line-height: 1.1;
                margin-left: 8px;
            }
        }
    }
    svg {
        display: block;
        opacity: 0.6;
    }
`;

const List = styled.ul``;

export default Cooperation;
